import '../css/agreement.css'


const Agreement = () => {

    return (
<div class="agreement">
<p class="agreement_title">OPĆI UVJETI POSLOVANJA 2023</p>
<p class="agreement_subtitle">FLUXER SOFTWERSKA PLATFORMA</p>
<p class="agreement_article">
Članak 1.
</p>
<p class="agreement_text">
Tekst koji slijedi predstavlja Opće uvjete poslovanja koji reguliraju na općoj razini međusobna prava i obveze između Korisnika, ovlašćenog distributera i pružatelja usluga sofwerske platforme Fluxer. 
Ne dirajući u stavak 1. ovog članka, Korisnici koji nisu registrirani i pristupaju i pregledavaju Fluxer platformu pristaju samim pristupom na Fluxer platformu na ove Opće uvjete i sve dijelove posebnih ugovornih pravila koji reguliraju pružanje usluga i aktivnosti korisnika na Fluxer platformi. Time su upoznati i pristaju na isključenja odgovornosti Elektro tim d.o.o. kao nositelja sofwerske platforme u odnosima u kojima je izrijekom ovim općim uvjetima ili posebnim ugovornim pravilima isključeno Elektro tim d.o.o. stranačko svojstvo.
Ovi opći ugovorni uvjeti se primjenjuju u cijelosti pored i istovremeno s pravnim pravilima Posebnih ugovornih odnosa pri čemu se neće primijeniti samo oni dijelovi Općih uvjeta koji su izrijekom isključeni posebnim ugovornim pravilima ili koji se očigledno ne odnose niti posredno na pojedini ugovorni odnos. Nabrajanje pojedinih općih uvjeta u posebnim ugovornim pravilima ne isključuje primjenu ostalih odredbi općih uvjeta prema pravilu iz prethodne rečenice. 
Registrirani korisnici prihvaćaju u potpunosti ove Opće uvjete poslovanja i Posebna ugovorna pravila kao pravila koja reguliraju sve međusobne pravne odnose koji mogu nastati korištenjem Fluxer sofwerske platforme. 
</p>
<p class="agreement_article">
Članak 2.
</p>
<p class="agreement_text">
Subjekti pravnih odnosa u vezi Fluxer platforme su:
Trgovačko društvo Elektro tim d.o.o. Banjaluka, Šargovačka 31, 78 000 Banjaluka nositelj Fluxer platforme, dalje u tekstu:  Elektro tim”.
Distributer koji je ovlašten Fluxer platformu stavljati u promet na određenom Terotorijumu, ali uz prethodno pisano odobrenje od strane Elektro tim d.o.o. 
Korisnici su pravne osobe, koji koji koriste usluge na način koji je ponuđen na Fluxer platformi. 
</p>
<p class="agreement_article">
Članak 3.
</p>
<p class="agreement_text">
Elektro tim d.o.o. zadržava pravo jednostrano i bez prethodnog upozorenja izmijeniti ili dopuniti ove Opće uvjete ili ih zamijeniti potpuno novim. Izmjena ili dopuna općih uvjeta ima pravni učinak od dana njihove objave na platformi za sve stranke koje su već prihvatile opće uvjete.
Ne dirajući u prethodni stavak, za novo registrirane stranke vrijedit će Opći uvjeti koji su prihvaćeni u trenutku registriranja, i sve buduće izmjene sukladno prethodnom stavku.
Stranke su suglasne da Posebna ugovorna pravila imaju prednost pred Općim uvjetima ako posebna ugovorna pravila uređuju neki dio pravnog odnosa korisnika Fluxer platforme drugačije od Općih uvjeta.
Pod posebnim ugovornim pravilima u smislu prethodnog stavka smatraju posebna ugovorna pravila koja proizlaze iz pojedinog ugovora sklopljenog između distributera sofwerske platforme za određeni teritorij  i trećih subjekata.
Nastavak posjećivanja i korištenja Fluxer platforme u bilo kojem segmentu znači i pristanak svih stranaka na sve izmjene i dopune koje se odnose na pravila koja reguliraju svaku vrstu posjeta i korištenja Fluxer platforme.
Korisnici i treće osobe na koje se primjenjuju ovi opći su dužni pratiti izmjene i dopune na svoju inicijativu te pristaju da Elektro tim izvrši takve izmjene i dopune bez prethodne najave i navođenja razloga.
Informacije i sadržaj Elektro tim može mijenjati jednostrano bez prethodne najave i navođenja razloga. Elektro tim ne odgovara za štetu, ozljedu, umanjenje vrijednosti, propuštenu zaradu i druge imovinske i neimovinske štete koje bi nastale uslijed takve izmjene sadržaja na Fluxer platformi.
</p>
<p class="agreement_article">
Članak 4.
</p>
<p class="agreement_text">
Matični sadržaj je sadržaj koji obavi ili prenese Elektro tim u okviru obavljanja svoje djelatnosti.
Korisnički sadržaj je sadržaj koji kreiraju korisnici.
Sadržaj u smislu ove odredbe znači vizualni, tekstualni i drugi oblici sadržaja.
Ove odredbe se odnose na svaki sadržaj kreiran i publiciran na Fluxer platformi neovisno tko ga je publicirao upotrebom bilo koje funkcije za kreiranje i publiciranje sadržaja.
Elektro tim ne preuzima odgovornost za točnost ili pouzdanost niti jednog  podatka sadržanog ili kreiranog na Fluxer platformi. Takav sadržaj korisnici i treći koriste na vlastitu odgovornost.
</p>
<p class="agreement_article">
Članak 5.
</p>
<p class="agreement_text">
Svi audio, vizualni, pisani i drugi sadržaji i materijali objavljeni na platformi pripadaju, u smislu autorskih i srodnih prava, u pravilu ,Elektro tim. 
Bilo kakva upotreba ili prijenos ili obrada sadržaja koji je zaštićen autorskim ili srodnim pravom ili pravom industrijskog vlasništva u smislu Zakona je zabranjena ukoliko za istu nije ishođena izričita prethodna suglasnost / izričito dopuštenje nositelja tih autorskih i srodnih prava.
</p>
<p class="agreement_article">
Članak 6.
</p>
<p class="agreement_text">
Elektro tim se ne može smatrati odgovornim korsinicima ni trećim osobama za bilo kakvu štetu, gubitak ili ozljedu koji nastaju izravno ili posredno zbog  pristupa na Fluxer platformu ili korištenja ovih stranica ili stranica na koje vode linkovi na Fluxer platformi, ili  zbog informacija na ovim stranicama, kao niti zbog Elektro tim  aktivnosti ili propusta u svezi s informacijama, a niti zbog upotrebe / korištenja ili nemogućnosti korištenja Fluxer platforme.
Elektro tim također nije odgovoran za eventualnu štetu ili propuštenu dobit nastalu uslijed nemogućnosti pružanja svoje ugovorne usluge radi pogrešaka tehničke ili ljudske prirode. Stranke su suglasne i upoznate s činjenicom da se Fluxer platformi pristupa putem interneta i pristaju na sve štete i rizike od parcijalnog ili potpunog gubitka podataka i potpune ili parcijalne nemogućnosti pristupa platformi.
</p>
<p class="agreement_text">
Elektro tim niti u kojem slučaju nije nikome odgovoran za bilo kakvu izravnu ili neizravnu štetu nastalu korištenjem Fluxer platforme.
Elektro tim neće odgovarati za eventualnu štetu nastalom korištenjem podataka preuzetih s  Fluxer platforme. Svi podaci prikupljeni pomoću Fluxer platforme koriste se isključivo na vlastitu odgovornost.
Elektro tim u svakom trenutku zadržava pravo izmjene načina izvještavanja i formata izvještaja. 
</p>
<p class="agreement_article">
Članak 7.
</p>
<p class="agreement_text">
Elektro tim omogućuje svim korisnicima da svoje prigovore upute putem kontakt obrasca. Na sve primjedbe i prigovore Elektro tim  će odgovoriti najkasnije u roku od 15 dana od dana zaprimanja.
</p>
<p class="agreement_article">
Članak 8.
</p>
<p class="agreement_text">
Stranke se obvezuju cijelo vrijeme imati aktivnu adresu elektroničke pošte za komunikaciju s Elektro tim i ovlašćenim distruburterima te redovito odgovarati na primljene upite. Stranke su suglasne da će se komunikacija između Elektro tim  i stranaka odvijati primarno putem elektroničke pošte. 
</p>
<p class="agreement_article">
Članak 9.
</p>
<p class="agreement_text">
Na ove Opće uvjete primjenjuje se u cijelosti pravo Bosne i Herecgovine.
U slučaju bilo kakvog spora vezanog za tumačenje, stranke su suglasne da se uzme u prvom redu uzme u obzir kontekst i sistemsko tumačenje, narav obveze, pravna, ekonomska i gospodarska svrha.
Nadležan sud iz prethodnog stavka je Privredni sud u Banja Luci.
</p>
<p class="agreement_article">
Članak 10.
</p>
<p class="agreement_text">
Raskid ugovora na koje se primjenjuju ovi Opći uvjeti uređuje se pravilima trgovačkog i obveznog prava. Ne dirajući u zakonom propisane iznimke, Elektro tim ima pravo na razmjerni dio naknade za pružanje usluge do raskida.
</p>
<p class="agreement_signature">
ELEKTRO TIM D.O.O. 2023.
</p>
        </div>
    );
};

export default Agreement;
